const ResetRetryCountdown = (resendBtn, resendCode, timerEl, timerRunning, timer, remainingSeconds, callBack) => {
    const resendBtnCurrent = resendBtn.current;
    const resendCodeCurrent = resendCode.current;
    const timerCurrent = timerEl.current;

    if (timer.current) {
        clearInterval(timer.current);
    }

    let seconds = remainingSeconds;

    resendBtnCurrent.classList.add("opacity-50");
    resendBtnCurrent.classList.remove("resend-active");
    resendCodeCurrent.onclick = null;

    timerCurrent.textContent = `(${String(seconds).padStart(2, '0')})`;

    timer.current = setInterval(() => {
        seconds -= 1;
        if (seconds > 0) {
            timerCurrent.textContent = `(${String(seconds).padStart(2, '0')})`;
        } else {
            timerCurrent.textContent = '';
            resendBtnCurrent.classList.remove("resend-disabled", "opacity-50");
            resendBtnCurrent.classList.add("resend-active");
            resendCodeCurrent.onclick = callBack;

            clearInterval(timer.current);
            timer.current = null;
        }
    }, 1000);
};

export default ResetRetryCountdown;